import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { PusherService } from '../_service/pusher.service';
import { WaiterService } from '../_service/waiter.service';
import { CommonModule } from '@angular/common';
import { formatDistanceToNow } from 'date-fns';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss'
})
export class NotificationsComponent implements OnInit {
  total = 0;
  items: any[] = [];
  page = 1;
  loading = false;
  initialLoading = true;
  refreshing = false;
  totalPages: number = 0;

  constructor(
    private router: Router,
    private service: WaiterService,
    private pusherService: PusherService
  ) { }

  ngOnInit(): void {
    this.fetchAllNotifications();
    this.startTimeRefresh();
  }

  fetchAllNotifications() {
    if (this.loading) return;
    this.loading = true;

    this.service.fetchAllNotifications(this.page).subscribe({
      next: (res: any) => {
        this.items = res.data.map((notification: any) => ({
          ...notification,
          timeAgo: this.getTimeAgo(notification.created_at),
          isNew: this.isNotificationNew(notification.created_at)
        }));
        this.totalPages = res.last_page;
      },
      error: (err: any) => {
        console.error(err);
      },
      complete: () => {
        this.loading = false;
        this.initialLoading = false;
      }
    });
  }

  refreshNotifications() {
    this.refreshing = true;
    this.page = 1;

    setTimeout(() => {
      this.service.fetchAllNotifications(this.page).subscribe({
        next: (res: any) => {
          this.items = res.data.map((notification: any) => ({
            ...notification,
            timeAgo: this.getTimeAgo(notification.created_at),
            isNew: this.isNotificationNew(notification.created_at)
          }));
          this.totalPages = res.last_page;
        },
        error: (err: any) => {
          console.error(err);
        },
        complete: () => {
          this.refreshing = false;
        }
      });
    }, 800);
  }

  isNotificationNew(dateString: string): boolean {
    const notificationDate = new Date(dateString);
    const now = new Date();
    const diffInHours = (now.getTime() - notificationDate.getTime()) / (1000 * 60 * 60);
    return diffInHours < 24; // Consider notifications new if less than 24 hours old
  }

  getNotificationIcon(type: string): string {
    const iconMap: { [key: string]: string } = {
      'order': 'fa-shopping-cart',
      'payment': 'fa-credit-card',
      'review': 'fa-star',
      'system': 'fa-cog',
      'message': 'fa-comment',
      'alert': 'fa-exclamation-triangle',
      'default': 'fa-bell'
    };
    return iconMap[type] || iconMap['default'];
  }

  getNotificationColor(type: string): string {
    const colorMap: { [key: string]: string } = {
      'order': 'info',
      'payment': 'success',
      'review': 'warning',
      'system': 'secondary',
      'message': 'primary',
      'alert': 'danger',
      'default': 'primary'
    };
    return colorMap[type] || colorMap['default'];
  }

  getTimeAgo(dateString: string): string {
    try {
      const date = new Date(dateString);
      const timeAgo = formatDistanceToNow(date, { addSuffix: true });

      // Customize the output for better readability
      return timeAgo
        .replace('about ', '')
        .replace('less than a minute ago', 'just now')
        .replace('minute ago', 'min ago')
        .replace('minutes ago', 'mins ago')
        .replace('hour ago', 'hr ago')
        .replace('hours ago', 'hrs ago')
        .replace('day ago', 'd ago')
        .replace('days ago', 'd ago')
        .replace('month ago', 'mo ago')
        .replace('months ago', 'mo ago')
        .replace('year ago', 'y ago')
        .replace('years ago', 'y ago');
    } catch (error) {
      return 'just now';
    }
  }

  // Optional: Add a method to refresh times periodically
  startTimeRefresh() {
    setInterval(() => {
      this.items = this.items.map(notification => ({
        ...notification,
        timeAgo: this.getTimeAgo(notification.created_at)
      }));
    }, 60000); // Update every minute
  }

  // TrackBy function for performance optimization
  trackByNotification(index: number, notification: any): any {
    return notification.id || index;
  }
}
